import React from 'react';
interface HeaderProps {
  onNavigate: (view: string) => void;
}
export function Header({
  onNavigate
}: HeaderProps) {
  return <header className="bg-[#8B1538] text-white px-6 py-5 flex justify-between items-center sticky top-0 z-10 shadow-md border-b border-[#70102d]" data-id="element-14">
      <h1 className="text-lg font-semibold max-w-[70%] leading-tight tracking-tight" data-id="element-15">
        Jin’s Three Needles – Clinical Protocol Library
      </h1>
      <nav className="hidden sm:flex" data-id="element-16">
        <button onClick={() => onNavigate('overview')} className="text-[#FEE2E2] ml-4 text-sm hover:text-white hover:underline focus:outline-none bg-transparent border-none cursor-pointer transition-colors" data-id="element-17">
          Overview
        </button>
        <button onClick={() => onNavigate('technique')} className="text-[#FEE2E2] ml-4 text-sm hover:text-white hover:underline focus:outline-none bg-transparent border-none cursor-pointer transition-colors" data-id="element-18">
          Needling
        </button>
        <button onClick={() => onNavigate('about')} className="text-[#FEE2E2] ml-4 text-sm hover:text-white hover:underline focus:outline-none bg-transparent border-none cursor-pointer transition-colors" data-id="element-19">
          About Jin Rui
        </button>
      </nav>

      {/* Mobile Menu Button (simplified for this implementation) */}
      <div className="sm:hidden flex gap-3" data-id="element-20">
        <button onClick={() => onNavigate('overview')} className="text-xs text-[#FEE2E2]" data-id="element-21">
          Overview
        </button>
        <button onClick={() => onNavigate('technique')} className="text-xs text-[#FEE2E2]" data-id="element-22">
          Technique
        </button>
      </div>
    </header>;
}